export default __webpack_public_path__ + "static/media/go_back_32.45712fe0.svg";